import React, { useLayoutEffect, useRef, useState } from "react";
import { ChromePicker } from 'react-color';
import { TextField, Popover } from "@mui/material";

const ColorPicker = ({
    colour: colorExternal,
    index,
    disabled,
    onChange,
    delay = 200,
}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const [colorInternal, setColorInternal] = useState(colorExternal);

    useLayoutEffect(() => {
        setColorInternal(colorExternal);
    }, [colorExternal]);

    const outputTimeoutRef = useRef();

    const onChangeColor = (color) => {
        setColorInternal(color);

        clearTimeout(outputTimeoutRef.current);

        outputTimeoutRef.current = setTimeout(() => {
            onChange(color.hex, index);
        }, delay);
    }

    const handleOnClick = (event) => {
        if (disabled) return;

        setAnchorEl(anchorEl ? null : event.currentTarget);
    }

    const handleClickAway = () => {
        setAnchorEl(null);
    }

    return (

            <>
                {/* <ClickAwayListener onClickAway={handleClickAway}> */}
                    <TextField
                        id={`colorPicker-${index}`}
                        fullWidth
                        disabled={disabled}
                        label={'Color (hex)'}
                        value={colorExternal}
                        variant={'filled'}
                        onClick={handleOnClick}
                        InputProps={{
                            endAdornment: <ColorBox color={colorExternal} />
                        }}
                    />
                {/* </ClickAwayListener> */}
                <Popover
                    open={open}
                    onClose={handleClickAway}
                    anchorEl={anchorEl}
                    anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                    transformOrigin={{ horizontal: 'center', vertical: 'top' }}
                >
                    <ChromePicker
                        color={colorInternal}
                        onChange={onChangeColor}
                        disableAlpha
                    />
                </Popover>
            </>
    )
}

function ColorBox({ color }) {
    return (
        <div style={{ width: '24px', height: '20px', backgroundColor: color }}/>
    );
}

export default ColorPicker;